module.exports = __webpack_public_path__ + "static/media/appScreenShots.752afa0c.png";